import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './PlaceDetails.css';
import Logo from '../assets/logo.svg'; // Import SVG direktno kao komponentu

const PlaceDetails = () => {
    const { category_slug, slug, placeId } = useParams(); // Dohvati category_slug, slug i ID atrakcije
    const [place, setPlace] = useState(null); // Podaci o atrakciji
    const [activeTab, setActiveTab] = useState('description'); // Aktivni tab
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showFullText, setShowFullText] = useState(false); // Kontroliše prikazivanje celog teksta

    useEffect(() => {
        const fetchPlace = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/${category_slug}/${placeId}`);
                setPlace(response.data);
                setLoading(false);
            } catch (err) {
                console.error("Error fetching place details:", err);
                setError("Failed to load place details.");
                setLoading(false);
            }
        };

        fetchPlace();
    }, [category_slug, placeId]);

    if (loading) {
        return (
            <div className="loading-container">
                <img
                    src={Logo} // Učitavanje SVG fajla
                    alt="Loading logo"
                    className="loading-logo"
                />
                <p className="loading-text">Loading...</p>
            </div>
        );
    }

    if (error) {
        return <p>{error}</p>;
    }

    if (!place) {
        return <p>No details available for this place.</p>;
    }

    // Funkcija za ograničavanje teksta
    const truncatedText = (text, limit) => {
        if (!text || text.length <= limit) return text;
        return `${text.substring(0, limit)}...`;
    };

    return (
        <div className="place-details-page">
            {/* Sekcija sa pozadinskom slikom */}
            <div
                className="header-image"
                style={{
                    backgroundImage: `url(${place.image ? `${process.env.REACT_APP_BACKEND_URL}/${place.image}` : '/images/noimage.jpg'})`,
                }}
            >
                <div className="page-title-container">
                    <h1 className="page-title">{place?.title || 'Default Title'}</h1>
                    {place.away && <p className="page-distance">{place.away} away</p>}
                </div>
            </div>

            {/* Breadcrumb navigacija */}
            <div className="breadcrumb-container">
                <p className="breadcrumb">
                    <Link to={`/accommodations/${slug}`} className="breadcrumb-link">Home</Link>
                    <span className="breadcrumb-divider"> &gt; </span>
                    <Link to={`/accommodations/${slug}/${category_slug}`} className="breadcrumb-link">
                        {category_slug.replace(/-/g, ' ')}
                    </Link>
                    <span className="breadcrumb-divider"> &gt; </span>
                    <span className="current-page">{place.title}</span>
                </p>
            </div>

            {/* Tabs sekcija */}
            <div className="tabs">
                <button
                    className={`description-button ${activeTab === 'description' ? 'active' : ''}`}
                    onClick={() => setActiveTab('description')}
                >
                    Description
                </button>
                <button
                    className={`how-to-get-button ${activeTab === 'how_to_get' ? 'active' : ''}`}
                    onClick={() => setActiveTab('how_to_get')}
                >
                    How to get there
                </button>
            </div>

            {/* Tab sadržaj */}
            <div className="tab-content">
                {activeTab === 'description' && (
                    <>
                        <p>
                            {showFullText
                                ? place.description || 'No description available.'
                                : truncatedText(place.description, 500)}
                        </p>
                        {place.description && place.description.length > 500 && (
                            <button
                                className="read-more-button"
                                onClick={() => setShowFullText(!showFullText)}
                            >
                                {showFullText ? 'Show Less' : 'Read More'}
                            </button>
                        )}
                    </>
                )}
                {activeTab === 'how_to_get' && <p>{place.how_to_get || 'No information available.'}</p>}
            </div>

            {/* Dugme za lokaciju */}
            <div className="see-location-container">
                {place.google_maps_link ? (
                    <button
                        className="see-location-button"
                        onClick={() => window.open(place.google_maps_link, '_blank')}
                    >
                        See Location
                    </button>
                ) : (
                    <p className="location-not-available">Location not available</p>
                )}
            </div>
        </div>
    );
};

export default PlaceDetails;
